var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting-subscription-view"},[_c('h1',{staticClass:"welcome-text"},[_vm._v("Hallo und danke")])])
}]

export { render, staticRenderFns }